import { JourneyStep } from '../../types/journey-steps';

// Do not import this directly within a component.
// You should use the useJourneySteps function, as that
// will include the logic of which journey a user should be in.
export const defaultHolidaySearchJourney: JourneyStep[] = [
  {
    pathName: '/search-results/holidays/landing',
  },
  {
    name: 'Date',
    icon: 'vertical-nav-date.svg',
    pathName: '/search-results/dates',
    title: 'Date',
    fields: [{ name: 'arrivalDate' }, { name: 'duration' }],
  },
  {
    name: 'Park',
    icon: 'vertical-nav-location.svg',
    pathName: '/search-results/parks',
    title: 'Park',
    fields: [
      { name: 'parkCode' },
      { name: 'parks', multiSelect: true },
      { name: 'accommodationSubType', optional: true },
    ],
  },
  {
    name: 'Package',
    icon: 'vertical-nav-package.svg',
    pathName: '/search-results/packages',
    title: 'Holiday package',
    fields: [{ name: 'packageType' }],
  },
  {
    name: 'Accommodation',
    icon: 'vertical-nav-van.svg',
    pathName: '/search-results/grades',
    title: 'Accommodation',
    fields: [
      { name: 'selectedGradeName' },
      { name: 'selectedGradeCode' },
      { name: 'accommodationType', optional: true },
      { name: 'accommodationSubType', optional: true },
    ],
  },
  {
    name: 'Bedroom',
    icon: 'double-bed-darkblue.svg',
    pathName: '/search-results/bedrooms',
    title: 'No. of bedrooms',
    fields: [{ name: 'selectedBeds' }, { name: 'id' }, { name: 'gradeCode' }],
  },
  {
    name: 'Holiday details',
    pathName: '/search-results/holidays/details',
    title: 'Holiday details',
  },
];

export const packagesFirstHolidaySearchJourney: JourneyStep[] = [
  {
    pathName: '/search-results/holidays/landing',
  },
  {
    name: 'Package',
    icon: 'vertical-nav-package.svg',
    pathName: '/search-results/packages',
    title: 'Holiday package',
    fields: [{ name: 'packageType' }],
  },
  {
    name: 'Date',
    icon: 'vertical-nav-date.svg',
    pathName: '/search-results/dates',
    title: 'Date',
    fields: [{ name: 'arrivalDate' }, { name: 'duration' }],
  },
  {
    name: 'Park',
    icon: 'vertical-nav-location.svg',
    pathName: '/search-results/parks',
    title: 'Park',
    fields: [
      { name: 'parkCode' },
      { name: 'parks', multiSelect: true },
      { name: 'accommodationSubType', optional: true },
    ],
  },
  {
    name: 'Accommodation',
    icon: 'vertical-nav-van.svg',
    pathName: '/search-results/grades',
    title: 'Accommodation',
    fields: [
      { name: 'selectedGradeName' },
      { name: 'selectedGradeCode' },
      { name: 'accommodationType', optional: true },
      { name: 'accommodationSubType', optional: true },
    ],
  },
  {
    name: 'Bedroom',
    icon: 'double-bed-darkblue.svg',
    pathName: '/search-results/bedrooms',
    title: 'No. of bedrooms',
    fields: [{ name: 'selectedBeds' }, { name: 'id' }, { name: 'gradeCode' }],
  },
  {
    name: 'Holiday details',
    pathName: '/search-results/holidays/details',
    title: 'Holiday details',
  },
];
